

import { QuoteRequestInfo } from '@/models/quote-request-info';
import { computed, ComputedRef, defineComponent, PropType, ref, Ref, WritableComputedRef } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'QuoteRequestForm',
  props: {
    values: {
      type: Object as PropType<QuoteRequestInfo>,
      required: true,
      default: null
    }
  },
  setup(
      props,
      {emit}) {
    const store = useStore();
    const form: Ref<HTMLFormElement> = ref({} as HTMLFormElement);
    const formWasValidated: Ref<boolean> = ref(false);
    const tosAccepted: Ref<boolean> = ref(false);

    /**
     * Getter/Setter for the quote request info for internal use in this component.
     */

    const quoteRequestInfo: WritableComputedRef<QuoteRequestInfo> = computed({
      get(): QuoteRequestInfo {
        return props.values;
      },
      set(newValue: QuoteRequestInfo): void {
        emit('input', newValue);
      }
    });

    const addressRequired: ComputedRef<boolean> = computed(() => {
      return !quoteRequestInfo.value.sendViaMail;
    });

    /**
     * Returns the Terms-Of-Service / Privacy url
     */
    const tosUrl: ComputedRef<string> = computed(() => {
      return store.state.morticianSettings.privacyUrl || '#';
    });

    /**
     * Checks if the whole form is currently valid.
     */
    function checkFormValidity(): boolean {
      return form.value?.checkValidity() || false;
    }

    function formChanged(): void {
      formWasValidated.value = true;

      const isFormValid = checkFormValidity();
      emit('validationChanged', isFormValid);
    }

    return {
      formWasValidated,
      tosAccepted,
      quoteRequestInfo,
      addressRequired,
      tosUrl,
      formChanged,
      form
    };
  }
});
